// #region IMPORT
import React, { useState, useEffect, useRef } from 'react';
import { useAppNavigate } from '../../Hooks/back/useAppNavigate';
/** Components Import */
import {
  Stack,
  Box,
  Typography,
  Badge,
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListItemButton,
  Divider,
  IconButton,
  Card,
  CardContent,
  CardActions,
  TextField,
  Button as MuiButton,
  Tooltip,
} from '@mui/material';
import { Button, Combo, Dialog, Radio, Checkbox } from '../../Components/MUIs';
import { KakaoPost } from '../../Components/Kakaos';
import { FileForm } from '../../Components/FileForm/index';
/** Icons Import */
import {
  Settings as SettingsIcon,
  ModeEditOutline as PancilIcon,
  ContentPasteSearch as DocumentSearchIcon,
  Notifications as AlarmSettingIcon,
  CreditCard as CardIcon,
  PermPhoneMsg as InquireIcon,
  Logout as LogoutIcon,
  NavigateBefore as BackIcon,
  OpenInBrowserSharp,
  Help as HelpIcon,
  Check as CheckIcon,
  Close as CloseIcon,
} from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import { ReactComponent as UserIcon } from '../../Assets/Images/Moblie/user.svg';
import avata from '../../Assets/Images/Moblie/avata_160x160.png';
import Canvas from './../../Components/Canvas/Canvas';
import vector from '../../Assets/Images/Vector.png';
import Commons from '../../Services/Common/Common';
import safeonJourneyman1 from '../../Assets/Images/safeon_journeyman1.png';
import safeonJourneyman2 from '../../Assets/Images/safeon_journeyman2.png';
// #endregion

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

function Profile(props) {
  // #region 변수
  const { navigate } = useAppNavigate();
  const [kakaoPost, setKakaoPost] = useState(false); // 카카오 지도
  const signatureCanvas = useRef(); // 서명 REF
  // #endregion
  // #region 함수
  const GetPostData = (_data) => {
    props.setInputs({
      ...props.inputs,
      post: _data.road_address.zone_no,
      address1: _data.road_address.address_name,
    });
  };

  useEffect(() => {
    const isPageReloaded = sessionStorage.getItem('isPageReloaded');

    if (isPageReloaded) {
      // 새로고침이 감지되면 /mypage로 리다이렉트
      navigate('/mypage');
    } else {
      // 새로고침이 아닌 경우, 다음에 새로고침이 감지될 수 있도록 설정
      sessionStorage.setItem('isPageReloaded', 'true');
    }

    // cleanup: 컴포넌트 언마운트시 sessionStorage를 초기화 (다른 페이지 이동 시)
    return () => {
      sessionStorage.removeItem('isPageReloaded');
    };
  }, [navigate]);
  //# endregion

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          marginTop: '10px',
        }}
      >
        <IconButton
          onClick={() => {
            navigate('/MyPage');
          }}
        >
          <BackIcon fontSize="large" />
        </IconButton>
        <Tooltip
          enterTouchDelay={50}
          leaveTouchDelay={50}
          title="프로필 사진을 저장하기 위해서 카메라 접근을 허용하세요."
        >
          <IconButton>
            <HelpIcon color="info" />
          </IconButton>
        </Tooltip>
      </div>
      <Stack>
        <List>
          <ListItem
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <ListItemAvatar>
              <Badge
                overlap="circular"
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                badgeContent={
                  <>
                    <VisuallyHiddenInput
                      type="file"
                      accept="image/*"
                      id="upload-button"
                      onChange={(event) => {
                        const fileList = event.target.files;

                        if (Object.keys(fileList).length === 0) return;

                        const file = fileList[0]; // single file upload

                        const reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onload = (e) => {
                          fetch(e.target.result)
                            .then((res) => res.blob())
                            .then((blob) => {
                              const image = new File(
                                [blob],
                                `${new Date()
                                  .toISOString()
                                  .replace(/T/, '')
                                  .replace(/\..+/, '')
                                  .replace(/-/g, '')
                                  .replace(/:/g, '')}.png`,
                                {
                                  type: '/png',
                                }
                              );

                              props.setImageFile({
                                ...props.imageFile,
                                profileFiles: reader.result,
                                profileImage: image,
                                profileFileName: file.name,
                              });
                            });
                        };
                        reader.onerror = (error) => {
                          console.log(error);
                          // 파일 읽기 중 에러가 발생했을 때 실행될 코드
                        };
                      }}
                    />
                    <IconButton
                      onClick={() => {
                        document.getElementById('upload-button').click();
                      }}
                    >
                      <SettingsIcon />
                    </IconButton>
                  </>
                }
              >
                <Badge
                  overlap="circular"
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  badgeContent={
                    <IconButton
                      onClick={() => {
                        props.DeleteLogic2();
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  }
                >
                  {props.imageFile.profileFiles ? (
                    <>
                      <Avatar
                        sx={{ width: 80, height: 80 }}
                        src={props.imageFile.profileFiles}
                      />
                    </>
                  ) : (
                    <Box
                      sx={{
                        width: '80px',
                        height: '80px',
                        padding: '10px',
                        borderRadius: '50%',
                        backgroundColor: 'white',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <img src={avata} width="100%" height="100%"></img>
                    </Box>
                  )}
                </Badge>
              </Badge>
            </ListItemAvatar>
          </ListItem>
        </List>
        <List>
          <ListItem sx={{ pb: 2 }}>
            <Stack sx={{ width: '100%' }}>
              <Typography
                variant="body2"
                gutterBottom
                sx={{ color: 'gray', px: 1 }}
              >
                {props.lanInfo.length > 0
                  ? props.lanInfo.filter((f) => f.lanId === 'Id')[0].lanNm // 아이디
                  : ''}
              </Typography>
              <TextField
                fullWidth
                disabled
                value={props.inputs.id ? props.inputs.id : ''}
              />
            </Stack>
          </ListItem>
          <ListItem sx={{ pb: 2 }}>
            <Stack sx={{ width: '100%' }}>
              <Typography
                variant="body2"
                gutterBottom
                sx={{ color: 'gray', px: 1 }}
              >
                {props.lanInfo.length > 0
                  ? props.lanInfo.filter((f) => f.lanId === 'BirthDate')[0]
                      .lanNm // 생년월일
                  : ''}
              </Typography>
              <TextField
                fullWidth
                disabled
                value={
                  props.inputs.birth
                    ? props.inputs.birth.slice(0, 4) +
                      '-' +
                      props.inputs.birth.slice(4, 6) +
                      '-' +
                      props.inputs.birth.slice(6)
                    : ''
                }
              />
            </Stack>
          </ListItem>
          <ListItem sx={{ pb: 2 }}>
            <Stack sx={{ width: '100%' }}>
              <Typography
                variant="body2"
                gutterBottom
                sx={{ color: 'gray', px: 1 }}
              >
                {props.lanInfo.length > 0
                  ? props.lanInfo.filter((f) => f.lanId === 'Nationality')[0]
                      .lanNm // 국적
                  : ''}
              </Typography>
              <Combo
                fullWidth
                MenuProps={MenuProps}
                items={props.nationList}
                value={props.inputs.nation}
                onChange={(e) => {
                  props.setInputs({
                    ...props.inputs,
                    nation: e,
                  });
                }}
                sx={{
                  textAlign: 'start',
                  py: '8px',
                }}
                size="small"
              />
            </Stack>
          </ListItem>
          <ListItem sx={{ pb: 2 }}>
            <Stack sx={{ width: '100%' }}>
              <Typography
                variant="body2"
                gutterBottom
                sx={{ color: 'gray', px: 1 }}
              >
                {props.lanInfo.length > 0
                  ? props.lanInfo.filter((f) => f.lanId === 'BloodType')[0]
                      .lanNm // 혈액형
                  : ''}
              </Typography>
              <Combo
                fullWidth
                MenuProps={MenuProps}
                items={props.bloodList}
                value={props.inputs.blood}
                onChange={(e) => {
                  props.setInputs({
                    ...props.inputs,
                    blood: e,
                  });
                }}
                sx={{
                  textAlign: 'start',
                  py: '8px',
                }}
                size="small"
              />
            </Stack>
          </ListItem>
          <ListItem sx={{ pb: 2 }}>
            <Stack sx={{ width: '100%' }}>
              <Typography
                variant="body2"
                gutterBottom
                sx={{ color: 'gray', px: 1 }}
              >
                {props.lanInfo.length > 0
                  ? props.lanInfo.filter((f) => f.lanId === 'Name')[0].lanNm // 이름
                  : ''}
              </Typography>
              <TextField
                fullWidth
                value={props.inputs.name ? props.inputs.name : ''}
                onChange={(e) => {
                  props.setInputs({
                    ...props.inputs,
                    name: e.target.value,
                  });
                }}
              />
            </Stack>
          </ListItem>
          <ListItem sx={{ pb: 2 }}>
            <Stack sx={{ width: '100%' }}>
              <Typography
                variant="body2"
                gutterBottom
                sx={{ color: 'gray', px: 1 }}
              >
                {props.lanInfo.length > 0
                  ? props.lanInfo.filter((f) => f.lanId === 'EMail')[0].lanNm // 이메일
                  : ''}
              </Typography>
              <TextField
                fullWidth
                value={props.inputs.email ? props.inputs.email : ''}
                onChange={(e) => {
                  props.setInputs({
                    ...props.inputs,
                    email: e.target.value,
                  });
                }}
              />
            </Stack>
          </ListItem>
          <ListItem sx={{ pb: 2 }}>
            <Stack sx={{ width: '100%' }}>
              <Typography
                variant="body2"
                gutterBottom
                sx={{ color: 'gray', px: 1 }}
              >
                {props.lanInfo.length > 0
                  ? props.lanInfo.filter((f) => f.lanId === 'Tel')[0].lanNm // 전화번호
                  : ''}
              </Typography>
              <TextField
                fullWidth
                value={props.inputs.tel ? props.inputs.tel : ''}
                type="tel"
                inputProps={{ maxLength: 13 }}
                onChange={(e) => {
                  props.setInputs({
                    ...props.inputs,
                    tel: e.target.value
                      .replace(/[^0-9]/g, '')
                      .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, '$1-$2-$3')
                      .replace(/(\-{1,2})$/g, ''),
                  });
                }}
              />
            </Stack>
          </ListItem>
          <ListItem sx={{ pb: 2 }}>
            <Stack sx={{ width: '100%' }}>
              <Typography
                variant="body2"
                gutterBottom
                sx={{ color: 'gray', px: 1 }}
              >
                {props.lanInfo.length > 0
                  ? props.lanInfo.filter((f) => f.lanId === 'EmTel')[0].lanNm // 비상연락처
                  : ''}
              </Typography>
              <TextField
                fullWidth
                value={props.inputs.emtel ? props.inputs.emtel : ''}
                type="tel"
                inputProps={{ maxLength: 13 }}
                onChange={(e) => {
                  props.setInputs({
                    ...props.inputs,
                    emtel: e.target.value
                      .replace(/[^0-9]/g, '')
                      .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, '$1-$2-$3')
                      .replace(/(\-{1,2})$/g, ''),
                  });
                }}
              />
            </Stack>
          </ListItem>
          <ListItem sx={{ pb: 2 }}>
            <Stack sx={{ width: '100%' }}>
              <Typography
                variant="body2"
                gutterBottom
                sx={{ color: 'gray', px: 1 }}
              >
                {props.lanInfo.length > 0
                  ? props.lanInfo.filter((f) => f.lanId === 'Post')[0].lanNm // 우편번호
                  : ''}
              </Typography>
              <Stack
                sx={{
                  width: '100%',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
                direction={'row'}
              >
                <TextField
                  fullWidth
                  disabled={
                    Commons.CheckMobileDevice() === 'ios' ? false : true
                  }
                  value={props.inputs.post ? props.inputs.post : ''}
                  onChange={(e) => {
                    props.setInputs({
                      ...props.inputs,
                      post: e.target.value,
                    });
                  }}
                />
                {Commons.CheckMobileDevice() !== 'ios' && (
                  <Button
                    sx={{
                      width: '40%',
                      height: '80%',
                      ml: 1,
                      borderRadius: 12,
                      backgroundColor: '#E9F0F1',
                      '&:hover': {
                        backgroundColor: '#E9F0F1', // hover 시 배경색
                      },
                      color: '#00602E',
                      fontWeight: 'bold',
                    }}
                    name={
                      props.lanInfo.length > 0
                        ? props.lanInfo.filter(
                            (f) => f.lanId === 'SearchAddress'
                          )[0].lanNm // 주소 검색
                        : ''
                    }
                    onClick={() => setKakaoPost(true)}
                  />
                )}
              </Stack>
            </Stack>
          </ListItem>
          <ListItem sx={{ pb: 2 }}>
            <Stack sx={{ width: '100%' }}>
              <Typography
                variant="body2"
                gutterBottom
                sx={{ color: 'gray', px: 1 }}
              >
                {props.lanInfo.length > 0
                  ? props.lanInfo.filter((f) => f.lanId === 'Address')[0].lanNm // 주소(Address)
                  : ''}
              </Typography>
              <TextField
                fullWidth
                disabled={Commons.CheckMobileDevice() === 'ios' ? false : true}
                value={props.inputs.address1 ? props.inputs.address1 : ''}
                onChange={(e) => {
                  props.setInputs({
                    ...props.inputs,
                    address1: e.target.value,
                  });
                }}
              />
            </Stack>
          </ListItem>
          <ListItem sx={{ pb: 2 }}>
            <Stack sx={{ width: '100%' }}>
              <Typography
                variant="body2"
                gutterBottom
                sx={{ color: 'gray', px: 1 }}
              >
                {props.lanInfo.length > 0
                  ? props.lanInfo.filter((f) => f.lanId === 'AddressDtl')[0]
                      .lanNm // 나머지주소
                  : ''}
              </Typography>
              <TextField
                fullWidth
                value={props.inputs.address2 ? props.inputs.address2 : ''}
                onChange={(e) => {
                  props.setInputs({
                    ...props.inputs,
                    address2: e.target.value,
                  });
                }}
              />
            </Stack>
          </ListItem>
          <ListItem sx={{ pb: 2 }}>
            <Stack sx={{ width: '100%' }}>
              <Typography
                variant="body2"
                gutterBottom
                sx={{ color: 'gray', px: 1 }}
              >
                {props.lanInfo.length > 0
                  ? props.lanInfo.filter((f) => f.lanId === 'Experience')[0]
                      .lanNm // 경력유무
                  : ''}
              </Typography>
              <Radio
                row
                value={props.inputs.careerYn ? props.inputs.careerYn : 'N'}
                onChange={(e) => {
                  if (e === 'Y') {
                    props.setInputs({
                      ...props.inputs,
                      careerYn: e,
                    });
                  } else {
                    props.setInputs({
                      ...props.inputs,
                      careerYn: e,
                      careerPeriod: null,
                    });
                  }
                }}
                items={[
                  { value: 'Y', name: '예' },
                  { value: 'N', name: '아니오' },
                ]}
              />
            </Stack>
          </ListItem>
          <ListItem sx={{ pb: 3 }}>
            <Stack sx={{ width: '100%' }}>
              <Typography
                variant="body2"
                gutterBottom
                sx={{ color: 'gray', px: 1 }}
              >
                {props.lanInfo.length > 0
                  ? props.lanInfo.filter((f) => f.lanId === 'CareerPeriod')[0]
                      .lanNm // 경력기간
                  : ''}
              </Typography>
              <Combo
                fullWidth
                MenuProps={MenuProps}
                items={props.careerPeriodList}
                value={
                  props.inputs.careerYn === 'N' ? '' : props.inputs.careerPeriod
                }
                onChange={(e) => {
                  props.setInputs({
                    ...props.inputs,
                    careerPeriod: e,
                  });
                }}
                sx={{
                  textAlign: 'start',
                  py: '8px',
                }}
                size="small"
                disabled={props.inputs.careerYn === 'N' ? true : false}
              />
            </Stack>
          </ListItem>
          <ListItem sx={{ pb: 3 }}>
            <Stack
              sx={{
                width: '100%',
                justifyContent: 'space-between',
              }}
              direction="row"
            >
              <Typography
                variant="body2"
                gutterBottom
                sx={{ color: 'gray', px: 1, my: 0 }}
              >
                {props.lanInfo.length > 0
                  ? props.lanInfo.filter((f) => f.lanId === 'HealthCard')[0]
                      .lanNm // 보건카드
                  : ''}
              </Typography>
              <Button
                sx={{
                  borderRadius: 12,
                  backgroundColor: '#E9F0F1',
                  '&:hover': {
                    backgroundColor: '#E9F0F1', // hover 시 배경색
                  },
                  color: '#00602E',
                  fontWeight: 'bold',
                }}
                name={
                  props.lanInfo.length > 0
                    ? props.lanInfo.filter((f) => f.lanId === 'Look')[0].lanNm // 보기
                    : ''
                }
                onClick={() => {
                  props.SearchLogic(props.inputs.healthImage, 'health');
                  props.setImageDialog(true);
                }}
              />
            </Stack>
          </ListItem>
          <ListItem sx={{ pb: 3 }}>
            <Stack sx={{ width: '100%' }}>
              <Typography
                variant="body2"
                gutterBottom
                sx={{ color: 'gray', px: 1 }}
              >
                {props.lanInfo.length > 0
                  ? props.lanInfo.filter((f) => f.lanId === 'Visa')[0].lanNm // Visa
                  : ''}
              </Typography>
              <TextField
                fullWidth
                value={props.inputs.visa ? props.inputs.visa : ''}
                onChange={(e) => {
                  props.setInputs({
                    ...props.inputs,
                    visa: e.target.value,
                  });
                }}
              />
            </Stack>
          </ListItem>
          <ListItem sx={{ pb: 3 }}>
            <Stack
              sx={{
                width: '100%',
                justifyContent: 'space-between',
              }}
              direction="row"
            >
              <Typography
                variant="body2"
                gutterBottom
                sx={{ color: 'gray', px: 1, my: 0 }}
              >
                {props.lanInfo.length > 0
                  ? props.lanInfo.filter((f) => f.lanId === 'SignatureName')[0]
                      .lanNm // 서명
                  : ''}
              </Typography>
              <Button
                sx={{
                  borderRadius: 12,
                  backgroundColor: '#E9F0F1',
                  '&:hover': {
                    backgroundColor: '#E9F0F1', // hover 시 배경색
                  },
                  color: '#00602E',
                  fontWeight: 'bold',
                }}
                name={
                  props.lanInfo.length > 0
                    ? props.lanInfo.filter((f) => f.lanId === 'Look')[0].lanNm // 보기
                    : ''
                }
                onClick={() => {
                  props.SearchLogic(props.inputs.sign, 'sign');
                  props.setSignDialog(true);
                }}
              />
            </Stack>
          </ListItem>
          {(props.userInfo.authCd === 'BUSINESS_OWNER' ||
            props.userInfo.authCd === 'ADMIN') && (
            <ListItem sx={{ pb: 3 }}>
              <Stack
                sx={{
                  width: '100%',
                  justifyContent: 'space-between',
                }}
                direction="row"
              >
                <Typography
                  variant="body2"
                  gutterBottom
                  sx={{ color: 'gray', px: 1, my: 0 }}
                >
                  직인
                </Typography>
                <Button
                  sx={{
                    borderRadius: 12,
                    backgroundColor: '#E9F0F1',
                    '&:hover': {
                      backgroundColor: '#E9F0F1', // hover 시 배경색
                    },
                    color: '#00602E',
                    fontWeight: 'bold',
                  }}
                  name={
                    props.lanInfo.length > 0
                      ? props.lanInfo.filter((f) => f.lanId === 'Look')[0].lanNm // 보기
                      : ''
                  }
                  onClick={() => {
                    props.SearchLogic(props.inputs.journeyman, 'journeyman');
                    props.setModalToggle5(true);
                  }}
                />
              </Stack>
            </ListItem>
          )}
          <ListItem sx={{ pt: 2 }}>
            <Button
              sx={{
                color: 'rgba(0,0,0,0.5)',
                fontSize: '16px',
              }}
              variant="text"
              name={'회원탈퇴 >'}
              onClick={() => {
                props.setModalToggle4(true);
              }}
            />
          </ListItem>
          <ListItem sx={{ pt: 2 }}>
            <Button
              fullWidth
              name={
                props.lanInfo.length > 0
                  ? props.lanInfo.filter((f) => f.lanId === 'Save')[0].lanNm // 저장
                  : ''
              }
              onClick={() => {
                props.SaveLogic1();
              }}
            />
          </ListItem>
        </List>
        <KakaoPost
          open={kakaoPost}
          onClose={() => setKakaoPost(false)}
          title={
            props.lanInfo.length > 0
              ? props.lanInfo.filter((f) => f.lanId === 'SearchAddress')[0]
                  .lanNm // 주소 검색
              : ''
          }
          ReceivePost={(_data) => GetPostData(_data)}
        />
        {/* 보건카드 팝업창 */}
        {props.imageDialog && (
          <Dialog
            title={
              props.lanInfo.length <= 0
                ? ''
                : props.lanInfo.find(
                    (f) => f.lanType !== 'MENU' && f.lanId === 'ImageSetup'
                  ).lanNm
            } //사진 설정
            open={props.imageDialog}
            onClose={(e) => {
              props.setImageFile({
                ...props.imageFile,
                healthFiles: '',
                healthImage: '',
              });
              props.setImageDialog(false);
            }}
            contentSx={{
              display: 'flex',
              flexDirection: 'column',
              height: '50vh',
            }}
            fullWidth
            saveButtonName={
              props.lanInfo.length <= 0
                ? ''
                : props.lanInfo.find(
                    (f) => f.lanType == 'CALL' && f.lanId === 'Save'
                  ).lanNm
            } //저장
            closeButtonName={
              props.lanInfo.length <= 0
                ? ''
                : props.lanInfo.find(
                    (f) => f.lanType == 'CALL' && f.lanId === 'Close'
                  ).lanNm
            } //닫기
            useSaveButton={true}
            useSaveAfterClose={false}
            onSave={() => {
              props.SaveLogic2();
              if (props.imageFile.healthImage) {
                props.setImageFile({
                  ...props.imageFile,
                  healthFiles: '',
                  healthImage: '',
                });
                props.setImageDialog(false);
              }
            }}
            maxWidth="sm"
            content={
              <div
                className="ag-theme-alpine no-scroll"
                style={{
                  width: '100%',
                  height: '100%',
                  alignContent: 'center',
                }}
              >
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <FileForm
                    datas={[
                      {
                        type: 'file',
                        name:
                          props.lanInfo.length <= 0
                            ? ''
                            : props.lanInfo.find(
                                (f) => f.lanType == 'CALL' && f.lanId === 'File'
                              ).lanNm, //파일
                        onChange: (event) => {
                          const fileList = event.target.files;
                          if (Object.keys(fileList).length === 0) return;

                          const file = fileList[0]; // single file upload

                          const reader = new FileReader();
                          reader.readAsDataURL(file);
                          reader.onload = (e) => {
                            fetch(e.target.result)
                              .then((res) => res.blob())
                              .then((blob) => {
                                const image = new File(
                                  [blob],
                                  `${new Date()
                                    .toISOString()
                                    .replace(/T/, '')
                                    .replace(/\..+/, '')
                                    .replace(/-/g, '')
                                    .replace(/:/g, '')}.png`,
                                  {
                                    type: 'image/png',
                                  }
                                );

                                props.setImageFile({
                                  ...props.imageFile,
                                  healthFiles: reader.result,
                                  healthImage: image,
                                  healthFileName: file.name,
                                });
                              });
                          };
                          reader.onerror = (error) => {
                            console.log(error);
                            // 파일 읽기 중 에러가 발생했을 때 실행될 코드
                          };
                        },
                        buttonName:
                          props.lanInfo.length == 0
                            ? ''
                            : props.lanInfo.find(
                                (f) =>
                                  f.lanType == 'CALL' &&
                                  f.lanId === 'FileUpload'
                              ).lanNm, //파일 업로드
                      },
                    ]}
                  />
                  <Tooltip
                    enterTouchDelay={50}
                    leaveTouchDelay={50}
                    title="건강 검진표는 보건소에서 발급 받은 검진표의 사진을 등록하여 현장의 담당자에게 제출을 대신하기 위한 용도입니다."
                  >
                    <IconButton>
                      <HelpIcon color="info" />
                    </IconButton>
                  </Tooltip>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    height: '85%',
                    pt: 1.5,
                  }}
                >
                  {props.imageFile.healthFiles ? (
                    <img
                      id={'fileId'}
                      src={props.imageFile.healthFiles || ''}
                      style={{
                        maxWidth: '100%',
                        objectFit: 'contain',
                      }}
                    />
                  ) : (
                    <Typography variant="h6">
                      등록된 보건카드가 없습니다.
                    </Typography>
                  )}
                </Box>
              </div>
            }
          />
        )}
        {/* 서명 보기 팝업창 */}
        {props.signDialog && (
          <Dialog
            title={
              props.lanInfo.length == 0
                ? ''
                : props.lanInfo.find(
                    (f) => f.lanType !== 'MENU' && f.lanId === 'SignatureName'
                  ).lanNm
            } //서명
            titleSx={{ fontSize: '24px' }}
            open={props.signDialog}
            onClose={(e) => {
              props.setImageFile({
                ...props.imageFile,
                signFiles: '',
                signImage: '',
              });
              props.setSignDialog(false);
            }}
            contentSx={{
              display: 'flex',
              flexDirection: 'column',
              height: '50vh',
            }}
            fullWidth
            saveButtonName={
              props.lanInfo.length == 0
                ? ''
                : props.lanInfo.find(
                    (f) => f.lanType == 'CALL' && f.lanId === 'Save'
                  ).lanNm
            } //선택
            closeButtonName={
              props.lanInfo.length == 0
                ? ''
                : props.lanInfo.find(
                    (f) => f.lanType == 'CALL' && f.lanId === 'Close'
                  ).lanNm
            } //닫기
            useSaveButton={false}
            useSaveAfterClose={true}
            onSave={{}}
            maxWidth="sm"
            btnSx={{ width: '120px', height: '60px' }}
            content={
              <div
                className="ag-theme-alpine no-scroll"
                style={{
                  width: '100%',
                  height: '100%',
                  alignContent: 'center',
                }}
              >
                <MuiButton
                  sx={{
                    minWidth: '50%',
                    borderRadius: '8px',
                    backgroundColor: '#FFD839',
                    color: '#000000',
                    fontSize: 20,
                    // '&:hover': {
                    //     backgroundColor:
                    //         , // 원하는 hover 배경색으로 설정
                    // },
                  }}
                  onClick={(e) => {
                    props.setSignCreateDialog(true);
                  }}
                >
                  <img
                    src={vector}
                    alt="icon"
                    style={{
                      marginRight: 8,
                    }}
                  />
                  {'서명하기'}
                </MuiButton>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    height: '85%',
                    pt: 1.5,
                  }}
                >
                  <img
                    id={'fileId'}
                    src={props.imageFile.signFiles || ''}
                    style={{
                      maxWidth: '100%',
                      objectFit: 'contain',
                    }}
                  />
                </Box>
              </div>
            }
          />
        )}
        {/* 서명 등록 팝업창 */}
        {props.signCreateDialog && (
          <Dialog
            open={props.signCreateDialog}
            titleSx={{ fontSize: 25 }}
            onClose={(e) => props.setSignCreateDialog(false)}
            contentSx={{
              display: 'flex',
              height: '50vh',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            title={'서명 등록'}
            content={
              <Canvas
                signatureCanvas={signatureCanvas}
                userId={props.inputs.name}
              />
            }
            fullWidth
            saveButtonName={'저장'}
            closeButtonName={'닫기'}
            useSaveButton={true}
            useSaveAfterClose={false}
            maxWidth="md"
            onSave={(e) => {
              if (signatureCanvas.current) {
                const signatureDataUrl = signatureCanvas.current.toDataURL();
                props.setWorkSignature(signatureDataUrl);
                // handleOcr();
                const dataURL = signatureCanvas.current.toDataURL('image/png');

                // base64 데이터를 디코딩하여 Blob 생성
                const decodedData = atob(dataURL.split(',')[1]); // base64 부분만 분리하고 디코딩
                const byteNumbers = new Array(decodedData.length);

                // Uint8Array로 변환
                for (let i = 0; i < decodedData.length; i++) {
                  byteNumbers[i] = decodedData.charCodeAt(i);
                }

                const byteArray = new Uint8Array(byteNumbers);

                const blob = new Blob([byteArray], {
                  type: 'image/png',
                });
                const image = new File(
                  [blob],
                  `${new Date()
                    .toISOString()
                    .replace(/T/, '')
                    .replace(/\..+/, '')
                    .replace(/-/g, '')
                    .replace(/:/g, '')}.png`,
                  {
                    type: 'image/png',
                  }
                );
                if (!signatureCanvas.current._sigPad._isEmpty) {
                  props.SaveLogic3(image);
                  props.setSignCreateDialog(false);
                } else {
                  props.setSnackbar({
                    ...props.snackbar,
                    open: true,
                    message: '서명을 진행하세요.',
                    type: 'warning',
                  });
                }
              }
            }}
          />
        )}
        {/* 회원 탈퇴 팝업 창 */}
        {props.modalToggle4 && (
          <Dialog
            open={props.modalToggle4}
            titleSx={{ fontSize: 25 }}
            onClose={(e) => props.setModalToggle4(false)}
            contentSx={{
              display: 'flex',
              mb: 2,
            }}
            fullScreen
            title={'탈퇴 안내'}
            // btnSx={{
            //     width: '5vw',
            //     height: '4vh',
            //     fontSize: '2rem',
            // }}
            content={
              <Box>
                <Typography sx={{ fontSize: 17 }}>
                  ㆍ회원탈퇴를 신청하기 전에 안내 사항을 꼭 확인해주세요.
                </Typography>
                <Typography
                  sx={{
                    fontSize: 14,
                    mt: 2,
                    ml: 4,
                    fontWeight: 'bold',
                  }}
                >
                  <CheckIcon />
                  사용하고 계신 아이디(
                  {Commons.DecryptoAES(props.userInfo.userid)}
                  )는 탈퇴할 경우 데이터 재사용 및 복구가 불가능합니다.
                </Typography>
                {/* <Box sx={{ ml: 2, mt: 2 }}>
									<Typography
										sx={{ fontSize: 15, color: 'red' }}
									>
										탈퇴한 아이디는 본인과 타인 모두 재사용
										및 복구가 불가
									</Typography>
									<Typography sx={{ fontSize: 15 }}>
										하오니 신중하게 선택하시기 바랍니다.
									</Typography>
								</Box> */}
                <Typography
                  sx={{
                    fontSize: 14,
                    mt: 2,
                    ml: 4,
                    fontWeight: 'bold',
                  }}
                >
                  <CheckIcon />
                  탈퇴 후 회원정보 및 개인형 서비스 이용기록은 모두 삭제됩니다.
                </Typography>
                <Typography
                  sx={{
                    fontSize: 17,
                    mt: 5,
                    mb: 5,
                    color: 'red',
                  }}
                >
                  ㆍ탈퇴 후에는 아이디{' '}
                  {Commons.DecryptoAES(props.userInfo.userid)} 로 다시 가입할 수
                  없으며 아이디와 데이터는 복구할 수 없습니다.
                  <br />
                  ㆍ게시판형 서비스에 남아 있는 게시글은 탈퇴 후 삭제할 수
                  없습니다.
                </Typography>
                <Checkbox
                  name={'안내 사항을 모두 확인하였으며, 이에 동의합니다.'}
                  checked={props.idDelete}
                  onChange={(e) => props.setIdDelete(e)}
                  nameSx={{
                    fontSize: '16px',
                    mb: 5,
                  }}
                />
                <Box sx={{ display: 'flex' }}>
                  <Button
                    sx={{
                      marginX: 0.5,
                      width: '100%',
                      borderRadius: 2,
                      backgroundColor: '#E0EAE9',
                      '&:hover': {
                        backgroundColor: '#E0EAE9', // hover 시 배경색
                      },
                      color: '#00602E',
                      fontSize: '15px',
                      padding: '0px, 20px, 0px, 20px',
                    }}
                    size="medium"
                    name={'닫기'}
                    onClick={(e) => {
                      props.setModalToggle4(false);
                    }}
                  />
                  <Button
                    sx={{
                      marginX: 0.5,
                      width: '100%',
                      borderRadius: 2,
                      backgroundColor: '#2CA900',
                      '&:hover': {
                        backgroundColor: '#2CA900', // hover 시 배경색
                      },
                      color: '#FFFFFF',
                      //height: "5vh",
                      fontSize: '15px',
                      padding: '0px, 20px, 0px, 20px',
                    }}
                    size="medium"
                    name={'확인'}
                    onClick={(e) => {
                      if (props.idDelete) {
                        props.DeleteLogic1();
                      } else {
                        props.setSnackbar({
                          ...props.snackbar,
                          open: true,
                          message: '탈퇴 안내를 확인하고 동의하세요.',
                          type: 'warning',
                        });
                      }
                    }}
                  ></Button>
                </Box>
              </Box>
            }
            fullWidth
            saveButtonName={'확인'}
            closeButtonName={'닫기'}
            useSaveButton={false}
            useSaveAfterClose={false}
            maxWidth="md"
            onSave={(e) => {
              if (props.idDelete) {
                props.DeleteLogic1();
              } else {
                props.setSnackbar({
                  ...props.snackbar,
                  open: true,
                  message: '탈퇴 안내를 확인하고 동의하세요.',
                  type: 'warning',
                });
              }
            }}
          />
        )}
        {/* 직인 팝업 창 */}
        {props.modalToggle5 && (
          <Dialog
            title={
              props.lanInfo.length == 0
                ? ''
                : props.lanInfo.find(
                    (f) => f.lanType !== 'MENU' && f.lanId === 'ImageSetup'
                  ).lanNm
            } //사진 설정
            titleSx={{ fontSize: '24px' }}
            open={props.modalToggle5}
            onClose={(e) => {
              props.setImageFile({
                ...props.imageFile,
                journeyFiles: '',
                journeyImage: '',
              });
              props.setModalToggle5(false);
            }}
            contentSx={{
              display: 'flex',
              flexDirection: 'column',
              height: '40vh',
            }}
            fullWidth
            saveButtonName={
              props.lanInfo.length == 0
                ? ''
                : props.lanInfo.find(
                    (f) => f.lanType == 'CALL' && f.lanId === 'Save'
                  ).lanNm
            } //선택
            closeButtonName={
              props.lanInfo.length == 0
                ? ''
                : props.lanInfo.find(
                    (f) => f.lanType == 'CALL' && f.lanId === 'Close'
                  ).lanNm
            } //닫기
            useSaveButton={true}
            useSaveAfterClose={false}
            onSave={() => {
              props.SaveLogic4();
              if (props.imageFile.journeyImage) {
                props.setImageFile({
                  ...props.imageFile,
                  journeyFiles: '',
                  journeyImage: '',
                });
                props.setModalToggle5(false);
              }
            }}
            maxWidth="sm"
            btnSx={{ width: '120px', height: '60px' }}
            content={
              <div
                className="ag-theme-alpine no-scroll"
                style={{
                  width: '100%',
                  height: '100%',
                  alignContent: 'center',
                }}
              >
                <Button
                  sx={{
                    // backgroundColor: "#FFDE5A",
                    // color: "#000",
                    fontSize: '14px',
                    height: '38px',
                    borderRadius: '4px',
                    mb: 1,
                  }}
                  size="medium"
                  name={'직인 예시 보기'}
                  onClick={() => {
                    props.setModalToggle6(true);
                  }}
                />
                <FileForm
                  datas={[
                    {
                      type: 'file',
                      sx: { fontSize: 14 },
                      name:
                        props.lanInfo.length == 0
                          ? ''
                          : props.lanInfo.find(
                              (f) => f.lanType == 'CALL' && f.lanId === 'File'
                            ).lanNm, //파일
                      // value: props.imageFile.journeyFiles || "",
                      onChange: (event) => {
                        const fileList = event.target.files;
                        if (Object.keys(fileList).length === 0) return;

                        const file = fileList[0]; // single file upload

                        const reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onload = (e) => {
                          fetch(e.target.result)
                            .then((res) => res.blob())
                            .then((blob) => {
                              const canvas = document.createElement('canvas');
                              const ctx = canvas.getContext('2d');

                              const img = new Image();
                              img.crossOrigin = 'Anonymous'; // CORS 문제 방지
                              img.src = reader.result; // 원본 이미지

                              img.onload = function () {
                                canvas.width = img.width;
                                canvas.height = img.height;
                                ctx.drawImage(img, 0, 0);

                                const imageData = ctx.getImageData(
                                  0,
                                  0,
                                  canvas.width,
                                  canvas.height
                                );
                                const data = imageData.data;

                                // 특정 색(흰색) 제거: RGB(255,255,255)에 가까운 색을 투명화
                                for (let i = 0; i < data.length; i += 4) {
                                  const r = data[i]; // Red
                                  const g = data[i + 1]; // Green
                                  const b = data[i + 2]; // Blue
                                  const a = data[i + 3]; // Alpha (투명도)

                                  // 흰색(또는 거의 흰색)이라면 투명하게 변경
                                  if (r > 200 && g > 200 && b > 200) {
                                    data[i + 3] = 0; // 완전 투명하게 설정
                                  }
                                }

                                ctx.putImageData(imageData, 0, 0);

                                // Data URL 형태로 PNG 이미지로 변환
                                const transparentImage =
                                  canvas.toDataURL('image/png'); // 투명한 배경의 PNG 출력

                                // Data URL을 Blob으로 변환
                                fetch(transparentImage)
                                  .then((res) => res.blob()) // Blob으로 변환
                                  .then((blob) => {
                                    // Blob을 File 객체로 변환하여 저장
                                    const image = new File(
                                      [blob],
                                      `${new Date()
                                        .toISOString()
                                        .replace(/T/, '')
                                        .replace(/\..+/, '')
                                        .replace(/-/g, '')
                                        .replace(/:/g, '')}.png`,
                                      {
                                        type: 'image/png',
                                      }
                                    );

                                    props.setImageFile({
                                      ...props.imageFile,
                                      journeyFiles: transparentImage,
                                      journeyImage: image, // image 객체는 File 형태
                                      journeyFileName: file.name,
                                    });
                                  })
                                  .catch((err) => {
                                    console.error(
                                      'Error while converting image to Blob:',
                                      err
                                    );
                                  });
                              };
                            });
                        };
                        reader.onerror = (error) => {
                          console.log(error);
                          // 파일 읽기 중 에러가 발생했을 때 실행될 코드
                        };
                      },
                      buttonName:
                        props.lanInfo.length == 0
                          ? ''
                          : props.lanInfo.find(
                              (f) =>
                                f.lanType == 'CALL' && f.lanId === 'FileUpload'
                            ).lanNm, //파일 업로드
                    },
                  ]}
                />

                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    height: '90%',
                  }}
                >
                  {props.imageFile.journeyFiles ? (
                    <img
                      id={'fileId'}
                      src={props.imageFile.journeyFiles || ''}
                      style={{
                        maxWidth: '100%',
                        objectFit: 'contain',
                      }}
                    />
                  ) : (
                    <Typography variant="h4">
                      등록된 직인이 없습니다.
                    </Typography>
                  )}
                </Box>
              </div>
            }
          />
        )}
        {/* 직인 예시 팝업 창 */}
        {props.modalToggle6 && (
          <Dialog
            title={'직인 예시'}
            titleSx={{ fontSize: '24px' }}
            open={props.modalToggle5}
            onClose={(e) => {
              props.setImageFile({
                ...props.imageFile,
                journeyFiles: '',
                journeyImage: '',
              });
              props.setModalToggle5(false);
            }}
            contentSx={{
              display: 'flex',
              flexDirection: 'column',
              height: '20vh',
            }}
            fullWidth
            useSaveButton={true}
            useCloseButton={false}
            saveButtonName={'확인'}
            closeButtonName={''}
            useSaveAfterClose={false}
            onSave={() => {
              props.setModalToggle6(false);
            }}
            maxWidth="sm"
            btnSx={{ width: '120px', height: '60px' }}
            content={
              <Box
                className="ag-theme-alpine no-scroll"
                style={{
                  width: '100%',
                  height: '100%',
                  alignContent: 'center',
                }}
              >
                <Typography sx={{ fontSize: '14px', mb: 2 }}>
                  직인의 배경은 흰색 또는 투명해야 합니다.
                </Typography>
                <Stack
                  direction="row"
                  spacing={8}
                  sx={{
                    display: 'flext',
                    justifyContent: 'center',
                    alignContent: 'center',
                  }}
                >
                  <img
                    src={safeonJourneyman1}
                    style={{
                      maxWidth: '25%',
                      objectFit: 'contain',
                    }}
                  />
                  <img
                    src={safeonJourneyman2}
                    style={{
                      maxWidth: '25%',
                      objectFit: 'contain',
                    }}
                  />
                </Stack>
              </Box>
            }
          />
        )}
      </Stack>
    </>
  );
}

export default Profile;
